module.exports = __webpack_public_path__ + "r-v3/img/translation_KO.305c301b.png";